import React from 'react';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { ADMIN_TIME_OFF } from '@ApplicationWide/permissions/constants';
import { FEATURE_FLAG_WORKING_PATTERNS, FEATURE_FLAG_WORKING_PATTERNS_ADMIN } from '@ApplicationWide/feature-flags';

const AdminCreateWorkingPatternPage = React.lazy(() =>
  import('../../../pages/Admin/WorkingPatterns/AdminCreateWorkingPatternPage'),
);

const AdminEditWorkingPatternPage = React.lazy(() =>
  import('../../../pages/Admin/WorkingPatterns/AdminEditWorkingPatternPage'),
);

export default [
  {
    group: ADMIN,
    to: '/administration/working-patterns/create',
    route: '/administration/working-patterns/create',
    component: AdminCreateWorkingPatternPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_TIME_OFF,
    featureFlag: [FEATURE_FLAG_WORKING_PATTERNS_ADMIN, FEATURE_FLAG_WORKING_PATTERNS],
    hasNavBar: true,
  },
  {
    group: ADMIN,
    to: '/administration/working-patterns/duplicate/:id',
    route: '/administration/working-patterns/duplicate/:id',
    component: AdminCreateWorkingPatternPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_TIME_OFF,
    featureFlag: [FEATURE_FLAG_WORKING_PATTERNS_ADMIN, FEATURE_FLAG_WORKING_PATTERNS],
    hasNavBar: true,
  },
  {
    group: ADMIN,
    to: '/administration/working-patterns/edit/:id',
    route: '/administration/working-patterns/edit/:id',
    component: AdminEditWorkingPatternPage,
    requiredRoles: ['admin', 'super_admin'],
    adminVisibilityPermission: ADMIN_TIME_OFF,
    featureFlag: [FEATURE_FLAG_WORKING_PATTERNS_ADMIN, FEATURE_FLAG_WORKING_PATTERNS],
    hasNavBar: true,
  },
];
